import { SectionLabel } from '../ui/SectionLabel'

const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

const ROWS = [
  {
    dim: 'Memoria de tu voz',
    chatgpt: 'Cada sesión empieza de cero. Vuelves a pegar el mismo prompt.',
    gc: 'Perfil persistente. Aprende tono, vocabulario y audiencia una vez.',
    win: true,
  },
  {
    dim: 'Especializado en YouTube',
    chatgpt: 'Herramienta generalista. Sin estructura hook / intro / desarrollo / CTA.',
    gc: 'Pensado para guiones largos y Shorts con estructura narrativa.',
    win: true,
  },
  {
    dim: 'Regenerar una sección',
    chatgpt: 'Tienes que copiar, pegar y rezar para no romper el resto.',
    gc: 'Regeneras solo el bloque que no te gusta. El resto intacto.',
    win: true,
  },
  {
    dim: 'B-Roll cinematográfico',
    chatgpt: 'No existe. Te toca After Effects o stock genérico.',
    gc: '13 tipos de escena animadas con Remotion, generadas automáticamente.',
    win: true,
  },
  {
    dim: 'Pipeline de producción',
    chatgpt: 'Solo texto. Tu Kanban, calendario y analytics viven en 4 apps distintas.',
    gc: 'Kanban + calendario + analytics de YouTube + LinkedIn en una sola app.',
    win: true,
  },
  {
    dim: 'Historial que no se convierte en lastre',
    chatgpt: 'Chat history crece sin parar. Acabas "held hostage by your own chat history".',
    gc: 'Un proyecto por vídeo. Sin bloat. Sin scroll infinito.',
    win: true,
  },
  {
    dim: 'Escaleta ↔ Guion (mercado hispano)',
    chatgpt: 'No sabe lo que es una escaleta. Te devuelve siempre prosa completa.',
    gc: 'Toggle explícito. Cambias de bullets jerárquicos a prosa leíble en 1 click.',
    win: true,
  },
]

export function WhyNotChatGPT() {
  return (
    <section className="py-24 border-b border-ds-border bg-ds-surface">
      <div className={cx}>
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-6 lg:gap-16 mb-14 items-end">
          <div>
            <SectionLabel className="mb-5">La pregunta de siempre</SectionLabel>
            <h2 className="font-display font-black text-display-md tracking-tight2 uppercase text-ds-text">
              ¿Por qué no
              <br />
              simplemente <span className="italic text-ds-red">ChatGPT?</span>
            </h2>
          </div>
          <div>
            <blockquote className="font-sans italic text-[15px] sm:text-[17px] text-ds-muted leading-[1.7] border-l-2 border-ds-red pl-5 max-w-[520px]">
              "ChatGPT escribe como un robot intentando sonar humano. Todo sale suave y pulido y...
              muerto."
            </blockquote>
            <p className="font-display font-bold text-label tracking-caption uppercase text-ds-muted mt-3 pl-5">
              — Matt Giaro, "I Cancelled ChatGPT" · Substack, 2026-03
            </p>
          </div>
        </div>

        {/* Comparison grid */}
        <div className="border border-ds-border-mid">
          {/* Header row */}
          <div className="hidden md:grid grid-cols-[1.1fr_1.2fr_1.2fr] bg-ds-bg border-b border-ds-border-mid">
            <div className="p-5 font-display font-bold text-label tracking-label uppercase text-ds-muted">
              Dimensión
            </div>
            <div className="p-5 font-display font-bold text-label tracking-label uppercase text-ds-muted border-l border-ds-border-mid">
              ChatGPT / Jasper
            </div>
            <div className="p-5 font-display font-bold text-label tracking-label uppercase text-ds-red border-l border-ds-border-mid">
              GuionCreator
            </div>
          </div>

          {ROWS.map(({ dim, chatgpt, gc }, i) => (
            <div
              key={dim}
              className={`grid grid-cols-1 md:grid-cols-[1.1fr_1.2fr_1.2fr] ${i > 0 ? 'border-t border-ds-border-mid' : ''}`}
            >
              <div className="p-5 md:p-6 bg-ds-bg">
                <p className="font-display font-bold text-[13px] tracking-[0.06em] uppercase text-ds-text leading-[1.4]">
                  {dim}
                </p>
              </div>
              <div className="p-5 md:p-6 border-t md:border-t-0 md:border-l border-ds-border-mid bg-ds-bg">
                <div className="flex md:hidden font-display font-bold text-label tracking-caption uppercase text-ds-muted mb-2">
                  ChatGPT / Jasper
                </div>
                <p className="font-sans text-[13px] text-[#888] leading-[1.6]">
                  <span className="font-display font-bold text-ds-red opacity-60 mr-1.5">✕</span>
                  {chatgpt}
                </p>
              </div>
              <div className="p-5 md:p-6 border-t md:border-t-0 md:border-l border-ds-border-mid bg-ds-surface">
                <div className="flex md:hidden font-display font-bold text-label tracking-caption uppercase text-ds-red mb-2">
                  GuionCreator
                </div>
                <p className="font-sans text-[13px] text-ds-text leading-[1.6]">
                  <span className="font-display font-bold text-ds-red mr-1.5">—</span>
                  {gc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="font-sans text-[13px] text-ds-muted mt-6 leading-[1.6] max-w-[620px]">
          Nada contra ChatGPT. Es una herramienta general buena para muchas cosas. Pero si tu
          trabajo es publicar vídeo en YouTube todas las semanas,{' '}
          <span className="text-ds-text">el generalista te sale caro en horas.</span>
        </p>
      </div>
    </section>
  )
}
